import { DangerIcon } from "@cynthai/icons";
import { twMerge } from "tailwind-merge";

export default function InputErrorMessage({
  children,
  className,
  id,
}: {
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly id?: string;
}) {
  return (
    <div
      id={id}
      role="alert"
      className={twMerge(
        "flex flex-row items-center gap-2 text-xs text-danger",
        className,
      )}
    >
      <DangerIcon width={16} height={16} />
      {children}
    </div>
  );
}
